/**
 * Dashboard Page
 *
 * Main authenticated user dashboard.
 */

import React from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import {
  LayoutDashboard,
  User,
  File,
  Settings,
} from 'lucide-react';
import styles from './Dashboard.module.scss';

const { Title, Text } = Typography;

// =============================================================================
// COMPONENT
// =============================================================================

export const Dashboard: React.FC = () => {
  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <Title level={2}>Dashboard</Title>
        <Text type="secondary">
          Welcome back! Here's what's happening with your account.
        </Text>
      </div>

      <Row gutter={[24, 24]} className={styles.statsGrid}>
        <Col xs={24} sm={12} lg={6}>
          <Card className={styles.statCard}>
            <Statistic
              title="Total Items"
              value={0}
              prefix={<File style={{ width: '1em', height: '1em' }} />}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className={styles.statCard}>
            <Statistic
              title="Active Users"
              value={0}
              prefix={<User style={{ width: '1em', height: '1em' }} />}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className={styles.statCard}>
            <Statistic
              title="Pending Tasks"
              value={0}
              prefix={<LayoutDashboard style={{ width: '1em', height: '1em' }} />}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className={styles.statCard}>
            <Statistic
              title="Settings"
              value={0}
              prefix={<Settings style={{ width: '1em', height: '1em' }} />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} className={styles.contentGrid}>
        <Col xs={24} lg={16}>
          <Card title="Recent Activity" className={styles.card}>
            <div className={styles.placeholder}>
              <Text type="secondary">No recent activity to display.</Text>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={8}>
          <Card title="Quick Actions" className={styles.card}>
            <div className={styles.placeholder}>
              <Text type="secondary">Quick actions will appear here.</Text>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
